export default function getHourTimestamp() {
  const now = new Date();
  const currentUnixTime = Math.floor(now.getTime() / 1000); // Convert milliseconds to seconds
  const currentHourUnixTime = currentUnixTime - (currentUnixTime % 3600);

  return currentHourUnixTime * 1000;
}
